import { render, staticRenderFns } from "./TableCellOrderItemsSku.vue?vue&type=template&id=45c5955a&scoped=true"
import script from "./TableCellOrderItemsSku.vue?vue&type=script&lang=js"
export * from "./TableCellOrderItemsSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c5955a",
  null
  
)

export default component.exports